export enum AppPermission {
  Dashboard = 'app:dashboard',
  Appointments = 'app:appointments',
  Logbook = 'app:logbook',
  PatientList = 'app:patientlist',
  Documents = 'app:documents',
  Questionnaires = 'app:questionnaires',
  Diary = 'app:diary',
  Notes = 'app:notes',
  Tasks = 'app:tasks',
  PrivacyCockpit = 'app:privacycockpit',
  PrivacyCockpitSide = 'app:privacycockpitside',
  MedicalData = 'app:medicaldata',
  Account = 'app:account',
  Verification = 'app:verification',
  Identification = 'app:identification',
  JumpingPoint = 'app:jumpingpoint',
  Representations = 'app:representations',
  Messenger = 'app:messenger',
  Monitoring = 'app:monitoring',
  InactiveAccounts = 'app:inactiveaccounts',
  Documentation = 'app:documentation',
  Reconciliation = 'app:reconciliation',
  QuestionnaireRenderer = 'app:questionnaire-renderer',
  Emergency = 'app:emergency',
  Polavis = 'app:polavis',
  Materialpool = 'app:materialpool',
}
